import React, { JSX } from "react";
import { ColumnConfig, wafflesKeyColumnName } from "@app/shared/waffles";
import { Waffles } from "@app/shared/waffles/Waffles";
import { WafflesThemes } from "@app/shared/waffles/exports";
import { ServicingProviderDetail } from "@app/projects/results/servicing-provider/servicingProviderDetail";

interface MotiveScoresProps {
    record: ServicingProviderDetail;
  }

interface MotiveScoresWaffleToppings{
    [wafflesKeyColumnName]: string;
    domain: string;
    score: number;
}

const getColumnConfig = (): ColumnConfig => {
    return ({
      domain: {
        displayText: "Domain",
        noResize: true,
        noSort: true,
        testId: "motive-domain",
      },
      score: {
        displayText: "Tier",
        noResize: true, 
        noSort: true,
        testId: 'motive-score',
      },
    });
  };

const MotiveScores = (props: MotiveScoresProps): JSX.Element => {
    const getData = (): MotiveScoresWaffleToppings[] => {
        if (!props.record) {
          return [];
        }
        return props.record.motiveScoresDisplay.map((score, index) => {
            /* oxlint-disable sort-keys */
            return {
              [wafflesKeyColumnName]: index.toString(),
              domain: score?.domainDescription,
              score: score?.starValue,
            };
            /* oxlint-enable sort-keys */
          });
      }
    return (<React.Fragment>
        <div className="row">
          <div className={`data-box ${props.record?.motiveScoresDisplay?.length > 0 ? 'col-sm-6 col-lg-3' : 'col-12'} align-top`}>
            <Waffles<MotiveScoresWaffleToppings>
              columns={getColumnConfig()}
              data={getData() || []}
              fullWidth={true}
              testId={`servicing-provider-profile__motive-score`}
              theme={WafflesThemes.Flyout}
            />
          </div>
      </div>
    </React.Fragment>);
}

export default MotiveScores;